export default __webpack_public_path__ + "static/media/background-orange.cc704bb4.svg";